import {EventModelState, updateEventSolutionDetailsObject} from "src/state/slice/EventModelSlice";
import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "src/state/hooks";
import {Text} from "@amzn/stencil-react-components/text";
import {fetchContextAttributes} from "src/service/service";
import {getStage, isNullOrUndefined} from "src/util/commonUtil";
import {Stage} from "src/enum/enums";
import {logger} from "src/logger";
import {IContextAttribute} from "src/entity/entities";
import {ContextAttributesRegex, SolutionTypeNames, SolutionTypes, StringUtils} from "src/constant/constants";
import "src/components/authoringComponents/styles/MessageBoardContextAttributesComponent.scss";
interface ITextInput {
    attributeName: string;
    attributeValue: string;
}

/**
 * This component is used to display prefilled values for Context 360 Attributes in event solutions
 */
export const MessageBoardContextAttributesComponent = ({attributeName, attributeValue}: ITextInput) => {

    const dispatch = useAppDispatch();
    const eventModelState: EventModelState = useAppSelector(({eventModel}) => eventModel);
    const [context360Definition, setContext360Definition] = useState<string>(null);

    useEffect(() => {
        fetchContextAttributes(getStage() as Stage).then((response) => {
            const context360Definition = modifyContext360Definition(eventModelState, attributeName, attributeValue, response);
            setContext360Definition(context360Definition);
            dispatch(updateEventSolutionDetailsObject({
                [attributeName]: context360Definition
            }));
        })
    }, []);

    useEffect(() => {
        setContext360Definition(eventModelState?.eventSolution?.solutionDetailObject[SolutionTypeNames.IS_READ])
    }, [eventModelState?.eventSolution?.solutionDetailObject[SolutionTypeNames.IS_READ]]);

    const modifyContext360Definition = (eventModelState: EventModelState, attributeName: string, attributeValue: string, contextAttributes: IContextAttribute[]) => {
        switch (eventModelState?.eventSolution?.type) {
            case SolutionTypes.MESSAGE_BOARD: {
                if (attributeName === SolutionTypeNames.IS_READ) {
                    const match = attributeValue.match(ContextAttributesRegex.MESSAGE_BOARD_READ_CMSID_REFERENCE);
                    const cmsIdMatch = attributeValue.match(ContextAttributesRegex.MESSAGE_BOARD_READ_CMSID_VALUE);
                    const contextAttributeName = match ? match[1] : cmsIdMatch[1];
                    const filteredContextAttributes: IContextAttribute[] = contextAttributes.filter((contextAttribute) => contextAttribute.attributeName === contextAttributeName);
                    if (isNullOrUndefined(match)) { // ${cmsId} was not present in context definition which means an actual cms id was present
                        return attributeValue.replace(cmsIdMatch[2], eventModelState?.eventSolution?.solutionDetailObject[`${filteredContextAttributes[0].clientKeyName}`]);
                    }
                    if (filteredContextAttributes.length === 0) {
                        logger.error(`Context Attribute ${contextAttributeName} does not exist in EASE DB`);
                        return StringUtils.EMPTY;
                    } else if (filteredContextAttributes.length > 1) {
                        logger.error(`Some error in fetching Context Attributes for ${contextAttributeName}`);
                        return StringUtils.EMPTY;
                    } else { // contextAttributeName is partition key of Context Attributes table
                        return attributeValue.replace(new RegExp("\\$\\{\}", 'g'), `\${${filteredContextAttributes[0].clientKeyName}}`);
                    }
                } else {
                    return StringUtils.EMPTY;
                }
            }
            default:
                return StringUtils.EMPTY;
        }
    }

    return (
        context360Definition &&
        <Text className={"message-board-context-360"}>
            {context360Definition}
        </Text>
    )
}
